import React from 'react';
import Pagination from '@material-ui/lab/Pagination';
export default function PaginationList(props) {
  return (
    <div className="pagination">
      <Pagination count={props.count} page={props.page} onChange={props.handlePageChange} />
    </div>
  )
}